import Button from 'components/atoms/Button';
import { openModal } from 'actions/modal';
import { useThunkDispatch } from 'utils/reduxHook';
import { useContext } from 'react';
import { HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { SectionContentType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/types';

interface AddHubSectionButtonProps {
  scrollToAddedSection: () => void;
}

export default function AddHubSectionButton({ scrollToAddedSection }: AddHubSectionButtonProps) {
  // Get dispatch for global redux
  const globalDispatch = useThunkDispatch();
  // Get dispatch for Hub Authoring
  const dispatch = useContext(HubAuthoringDispatchContext);

  // Takes Section as an argument and pushes the related HubSection
  // to the sections array in the Redux store.
  const onAddSectionConfirm = (section: SectionContentType) => {
    dispatch({
      type: ActionType.addSection,
      section,
    });
    scrollToAddedSection();
  };

  return (
    <Button
      onClick={() => {
        globalDispatch(
          openModal('AddHubSection', {
            onConfirm: onAddSectionConfirm,
          }),
        );
      }}
      type="secondary"
      dataDurableId="AddSectionButton"
      text="Add a section"
    />
  );
}
